export default {
  "b2b.zdroj-editace-form.field.nazevCs.label": "Název CS",
  "b2b.zdroj-editace-form.field.nazevEn.label": "Název EN",
  "b2b.zdroj-editace-form.field.popisCs.label": "Popis CS",
  "b2b.zdroj-editace-form.field.popisEn.label": "Popis EN",
  "b2b.zdroj-editace-form.field.exkluzivita.label": "Exkluzivní",
  "b2b.zdroj-editace-form.field.maxPocetPozadavku.label":
    "Maximální počet požadavků",
  "b2b.zdroj-editace-form.field.pozadavekSmena.label": "Směnový",
  "b2b.zdroj-editace-form.field.platnostOd.label": "Platnost od",
  "b2b.zdroj-editace-form.button.delete": "Smazat",
  "b2b.zdroj-editace-form.button.submit": "Uložit",
  "b2b.zdroj-editace-form.button.cancel": "Zrušit",
  "b2b.zdroj-editace-widget.titleNew": "Nový zdroj",
  "b2b.zdroj-editace-form.save-dialog.title": "Uložení zdroje",
  "b2b.zdroj-editace-form.delete-dialog.title": "Odstranění zdroje"
};
